import React, { useState } from 'react';
import { View, Heading, Flex, Text, TextField, TextAreaField, Button, Card } from '@aws-amplify/ui-react';
import { FiMail, FiPhone, FiMapPin, FiSend } from 'react-icons/fi';

const ContactPage = () => {
    const [formData, setFormData] = useState({
        nombre: '',
        email: '',
        mensaje: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleWhatsAppSubmit = (e) => {
        e.preventDefault();
        
        // Configuración de WhatsApp
        const telefono = "14078738172"; 
        const texto = `Hola, Dr. Giovanni Scarvaci. Mi nombre es ${formData.nombre}. %0A%0A` +
                      `*Correo:* ${formData.email} %0A` +
                      `*Consulta:* ${formData.mensaje}`;
        
        const url = `https://wa.me/${telefono}?text=${texto}`;
        
        // Abrir WhatsApp en una nueva pestaña
        window.open(url, '_blank');
    };

    return (
        <View padding="40px 20px" backgroundColor="#ffffff">
            <Flex direction="column" alignItems="center" marginBottom="40px">
                <Heading level={2} color="#D4AF37">Contáctanos</Heading>
                <Text color="#333" textAlign="center">
                    Estamos listos para escuchar tu caso y ofrecer la consultoría legal que necesitas.
                </Text>
            </Flex>

            <Flex 
                direction={{ base: 'column', medium: 'row' }} 
                gap="30px" 
                maxWidth="1200px" 
                margin="0 auto"
            >
                {/* COLUMNA IZQUIERDA: FORMULARIO */}
                <Card flex="1" padding="30px" variation="elevated" borderRadius="15px">
                    <Heading level={4} marginBottom="20px" color="#001f3f">Envíanos un mensaje</Heading>
                    <form onSubmit={handleWhatsAppSubmit}>
                        <Flex direction="column" gap="20px">
                            <TextField
                                label="Nombre Completo"
                                name="nombre"
                                placeholder="Escriba su nombre"
                                value={formData.nombre}
                                onChange={handleChange}
                                required
                            />
                            <TextField
                                label="Correo Electrónico"
                                name="email"
                                type="email"
                                placeholder="ejemplo@correo.com"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                            <TextAreaField
                                label="Mensaje / Breve descripción de su consulta"
                                name="mensaje"
                                placeholder="¿En qué podemos ayudarle?"
                                rows={5}
                                value={formData.mensaje}
                                onChange={handleChange}
                                required
                            />
                            <Button 
                                type="submit"
                                fontSize="1.1rem"
                                style={{ backgroundColor: '#D4AF37', color: '#001f3f', fontWeight: 'bold', border: 'none' }}
                            >
                                <FiSend style={{marginRight: '10px'}} /> Enviar Consulta por WhatsApp
                            </Button>
                            <Text fontSize="12px" color="#666" textAlign="center">
                                Al hacer clic, se abrirá un chat directo con el Dr. Scarvaci.
                            </Text>
                        </Flex>
                    </form>
                </Card>

                {/* COLUMNA DERECHA: INFO Y MAPA */}
                <Card flex="1" padding="30px" variation="elevated" borderRadius="15px" backgroundColor="#fdfdfd">
                    <Heading level={4} color="#001f3f" marginBottom="20px">Nuestra Ubicación e Información</Heading>
                    
                    <Flex direction="column" gap="25px">
                        <Flex alignItems="flex-start" gap="15px">
                            <FiMapPin size="24px" color="#D4AF37" />
                            <View>
                                <Text fontWeight="bold" color="#001f3f">Visítanos en Maracay:</Text>
                                <Text color="#444"> Maracay, Estado Aragua, Venezuela.</Text>
                            </View>
                        </Flex>

                        <Flex alignItems="center" gap="15px">
                            <FiPhone size="24px" color="#D4AF37" />
                            <View>
                                <Text fontWeight="bold" color="#001f3f">Teléfono:</Text>
                                <Text color="#444">+1 (407) 873-8172</Text>
                            </View>
                        </Flex>

                        <Flex alignItems="center" gap="15px">
                            <FiMail size="24px" color="#D4AF37" />
                            <View>
                                <Text fontWeight="bold" color="#001f3f">Email:</Text>
                                <Text color="#444">giovanniscarvaciyasociados@gmail.com</Text>
                            </View>
                        </Flex>
                    </Flex>

                    {/* MAPA DE GOOGLE REAL */}
                    <View marginTop="30px" height="250px" borderRadius="10px" style={{overflow: 'hidden', border: '1px solid #ddd'}}>
                        <iframe 
                            title="Mapa Ubicacion"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3926.35715978434!2d-67.6045155!3d10.2489111!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e803ca63857d9b9%3A0xc133bc01003b!2sC.C.%20La%20Capilla%20I!5e0!3m2!1ses!2sve!4v1700000000000!5m2!1ses!2sve" 
                            width="100%" 
                            height="100%" 
                            style={{ border: 0 }} 
                            allowFullScreen="" 
                            loading="lazy"
                        ></iframe>
                    </View>
                </Card>
            </Flex>
        </View>
    );
};

export default ContactPage;